import styled, { css } from 'styled-components';
import { transparentize } from 'polished';
import { colors } from '@keen.io/colors';
export var Container = styled.div.withConfig({
  displayName: "SupportedIntervalstyles__Container",
  componentId: "keen-query-creator__sc-1qvoh97-0"
})(["&&&{padding:9px 9px 9px 9px;display:flex;flex-direction:row;flex-wrap:wrap;justify-content:space-evenly;}"]);
export var IntervalButton = styled.div.withConfig({
  displayName: "SupportedIntervalstyles__IntervalButton",
  componentId: "keen-query-creator__sc-1qvoh97-1"
})(["&&&{flex:1 0 22%;text-align:center;padding:10px;font-size:14px;border-radius:4px;color:", ";text-transform:capitalize;margin:5px;cursor:pointer;", ";}&&&:hover{background:", ";}&&&:focus-visible{outline:1px solid ", ";}"], colors.blue[500], function (props) {
  return props.isActive ? css(["background:", ";font-family:Lato Bold,sans-serif;"], transparentize(0.3, colors.green[100])) : css(["background:", ";font-family:Lato Medium,sans-serif;"], colors.white[400]);
}, transparentize(0.3, colors.green[100]), colors.lightBlue[500]);